import React, {Component} from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Alert from '@mui/lab/Alert'
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'


import AlertasTable from './AlertasTable'
import { AlertTitle, Collapse, Grid, Paper, Snackbar } from '@mui/material'

const {DateTime} = require('luxon')
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class AlertasPage extends Component{

  constructor() {
      super()
  
        //Definir fechas de inicio para los filtros de fecha
        var fechaInicioTemp = DateTime.local().set({hour: 0, minute: 0, second: 0})
        var fechaFinTemp = DateTime.local().set({hour: 23, minute: 59, second: 59})
  
        this.state = {
        entidades: [],
        cajeros: [],
        grupos: [],
        alertas: [],
        columnasAlerta: [],
        envio:[],
        busqueda: false,
        entidadAnterior: null,
 
  
        mostrarAlerta: false,
        mensajeAlerta: '',
        severidadAlerta: '',
        filtroFechaInicio: null,
        filtroFechaFin: fechaFinTemp
        };
  
        this.btnBuscarClick = this.btnBuscarClick.bind(this)
        this.btnEnviar = this.btnEnviar.bind(this)
  
        this.cmbGrupos = React.createRef()
        this.cmbCajeros = React.createRef()
        this.cmbEntidades = React.createRef()
  
  
        this.filtroFechaInicio = ""
        this.filtroFechaFin = ""
  }

  fechaFiltroChanged(origen, date) {
    if (date == null) return

    var formatoFechaInicio = "yyyy-LL-dd HH:mm:00"
    var formatoFechaFin = "yyyy-LL-dd HH:mm:59"

    switch (origen) {
      case 'inicio':
        this.setState({
          filtroFechaInicio: date
        })
        this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
        break;
      case 'fin':
        this.setState({
          filtroFechaFin: date
        })
        this.filtroFechaFin = date.toFormat(formatoFechaFin)
        break;
      default:

    }
  }

  btnBuscarClick() {
    this.queryAlertas()
  } 


  btnEnviar() {
    this.queryEnvio()
  } 

  handleCloseAlert= (event, reason) => {
    if (reason === 'clickaway') {
      return; // Evitar que se cierre si el usuario hace clic fuera
    }
    this.setState({ mostrarAlerta: false })
  }


  queryEnvio() {

      let filtroIdGrupo = null
      let filtroIdCajero = null
      const entidadId = this.state.entidadSeleccionada?.id;
  
  
      if(this.cmbGrupos.current.value !== 0){
        filtroIdGrupo = this.cmbGrupos.current.value
      }
  
      if(this.cmbCajeros.current.value !== 0){
        filtroIdCajero = this.cmbCajeros.current.value
      }
 
      if(!entidadId) {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Debe seleccionar una entidad',
              severidadAlerta: 'warning',
              busqueda :false
            })
        return
      }
      
      if(!filtroIdCajero) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Para realizar un envio debe seleccionar un cajero',
          severidadAlerta: 'warning'
        })
        return
      }

      if(!this.filtroFechaInicio) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Para realizar un envio debe seleccionar la fecha de inicio',
          severidadAlerta: 'warning'
        })
        return
      }

      if (entidadId !== this.state.entidadAnterior) {
        this.setState({
          alertas: [],
          busqueda: false
        });
      }
        
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
        filtro_id_grupo: filtroIdGrupo,
        filtro_id_cajero: filtroIdCajero,
        filtro_id_entidad: entidadId,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin: this.filtroFechaFin
      },
      url: process.env.REACT_APP_URL_BACKEND + '/alertas/envioCorreo'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        // alert("Error consultando grupos")
        //console.log('Error respuesta consultando grupos')
        this.setState({
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando grupos',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: `Correo enviado correctamente a ${data.correoDestino}`,
          severidadAlerta: 'success',
          envio: data
        });
        
      }
    })
  }


  queryEntidades() {
         
      var restArgs = {
        method: 'POST',
        headers: 'JSON',
        body: {},
        url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
      }
  
      RestTunel.makePetition(restArgs,(err, data) => {
        if(err) {
          // alert("Error consultando entidades")
          // console.log('Error respuesta consultando entidades')
          this.setState({
            entidades: [],
            mensajeError: data.message,
            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando entidades',
            severidadAlerta: 'error'
          })
        } else {
          //console.log('Entidades consultadas')
          
          this.setState({
            entidades: data
          })
        }
      })
    }

    queryCajeros() {
    
         var restArgs = {
          method: 'POST',
          headers: 'JSON',
          body: {},
          url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
        }
    
        RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            //alert("Error consultando cajeros")
            //console.log('Error respuesta consultando cajeros')
            this.setState({
              cajeros: [],
              mensajeError: data.message,
              mostrarAlerta: true,
              mensajeAlerta: 'Error consultando cajeros',
              severidadAlerta: 'error'
            })
          } else {
            // console.log('Cajeros consultados')
            this.setState({
              cajeros: data
            })
          }
      })
    }

    queryGrupos() {
        // console.log('Consultando grupos....')
            
        var restArgs = {
          method: 'POST',
          headers: 'JSON',
          body: {},
          url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list'
        }
    
        RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            // alert("Error consultando grupos")
            //console.log('Error respuesta consultando grupos')
            this.setState({
              grupos: [],
              mensajeError: data.message,
              mostrarAlerta: true,
              mensajeAlerta: 'Error consultando grupos',
              severidadAlerta: 'error'
            })
          } else {
            //console.log('Grupos consultados')
            this.setState({
              grupos: data
            })
          }
        })
    }

    queryAlertas() {
  
      var filtroIdGrupo = ''
      var filtroIdCajero = ''
      const entidadId = this.state.entidadSeleccionada?.id;

      console.log(entidadId)
  
  
  
      if(this.cmbGrupos.current.value !== 0){
        filtroIdGrupo = this.cmbGrupos.current.value
      }
  
      if(this.cmbCajeros.current.value !== 0){
        filtroIdCajero = this.cmbCajeros.current.value
      }
      
      /* if(this.cmbEntidades.current.value !== 0){
        filtroIdEntidad = this.cmbEntidades.current.value
      } */

        if(!entidadId) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Debe seleccionar una entidad',
          severidadAlerta: 'warning',
          busqueda :false
        })
        return
      }

     
      if(filtroIdGrupo === '' && filtroIdCajero === '') {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Debe seleccionar un grupo o un cajero',
          severidadAlerta: 'warning',
          busqueda :false
        })
        return
      }
  

      if (entidadId !== this.state.entidadAnterior) {
        this.setState({
          alertas: [],
          busqueda: false
        });
      }

      var restArgs = {
        method: 'POST',
        headers: 'JSON',
        body: {
          filtro_id_entidad: entidadId,
          filtro_id_grupo: filtroIdGrupo,
          filtro_id_cajero: filtroIdCajero,
          filtro_fecha_inicio: this.filtroFechaInicio,
          filtro_fecha_fin: this.filtroFechaFin
      },
        url: process.env.REACT_APP_URL_BACKEND + '/alertas/list2'
      }
  
      RestTunel.makePetition(restArgs,(err, data) => {
        if(err) {
          //alert("Error consultando depositos")
          // console.log('Error respuesta consultando depositos')
          this.setState({
            alertas: [],
            mensajeError: data.message,
            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando depositos',
            severidadAlerta: 'error',
            busqueda: false
          })
        } else {
          this.setState({
            alertas: (data && data.filas) || [],
            columnasAlerta: (data && data.columnas) || [],
            busqueda: true,
            entidadAnterior: entidadId
          })
        }
      })
    }


    componentDidMount() {
      this.queryGrupos()
      this.queryCajeros()
      this.queryEntidades()
    }
   
    render() {
    return (
      <Box>
        <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
          Operaciones 
        </Typography>
        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Buscar Operaciones:
              </Typography>
              <Grid container spacing={2} sx={{marginTop: 1}}> 
                <Grid item xs={12} sm="auto" sx={{ flexGrow: 0 }}>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <DateTimePicker
                        inputFormat="dd/MM/yyyy HH:mm"
                      label="Fecha/Hora Inicio"
                      value={this.state.filtroFechaInicio}
                      onChange={date => this.fechaFiltroChanged('inicio', date)}
                      renderInput={(params) => <TextField {...params} sx={{ width: { xs: '100%', md: 200 } }} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm="auto" sx={{ flexGrow: 0 }}>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <DateTimePicker
                        inputFormat="dd/MM/yyyy HH:mm"
                      label="Fecha/Hora fin"
                      value={this.state.filtroFechaFin}
                      onChange={date => this.fechaFiltroChanged('fin', date)}
                      renderInput={(params) => <TextField {...params} sx={{ width: { xs: '100%', md: 200 } }} />}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{marginTop: 1}}>
                <Grid item xs={12} sm="auto" sx={{ flexGrow: 0 }}>
                  <FormControl sx={{ width: { xs: '100%', md: 200 } }}> 
                    <InputLabel>Grupo</InputLabel>
                    <Select style={{width: 200}}
                      label="Entidad"
                      inputRef={this.cmbGrupos}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.grupos.map(grupo => (
                      <MenuItem key={grupo.id} value={grupo.id}>{grupo.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm="auto" sx={{ flexGrow: 0 }}>
                  <FormControl sx={{ width: { xs: '100%', md: 200 } }}>
                    <InputLabel>Cajero</InputLabel>
                    <Select style={{width: 200}}
                      label="Cajero"
                      inputRef={this.cmbCajeros}
                      defaultValue={0}>
                      <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.cajeros.map(cajero => (
                      <MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm="auto" sx={{ flexGrow: 0 }}>
                  <FormControl sx={{ width: { xs: '100%', md: 200 } }}>
                    <InputLabel>Entidad</InputLabel>
                    <Select
                                  label="Entidad"
                                 value={this.state.entidadTemporal?.id || 0}
                                  onChange={(e) => {
                                    const entidadId = e.target.value;
                                    const entidad = this.state.entidades.find(e => e.id === entidadId) || null;
                                    this.setState({ 
                                      entidadTemporal:entidad,
                                       entidadSeleccionada: entidad,
                                       busqueda: false
                                     });
                                  }}
                                >
                                  <MenuItem value={0}>-- Todas --</MenuItem>
                                  {this.state.entidades.map(entidad => (
                                    <MenuItem key={entidad.id} value={entidad.id}>{entidad.nombre}</MenuItem>
                                  ))}
                                </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="contained" size="large" onClick={this.btnBuscarClick}>Buscar</Button>
              <Button variant="contained" size="large" onClick={this.btnEnviar}>Enviar Correo</Button>
              <Snackbar
                open={this.state.mostrarAlerta}
                onClose={this.handleCloseAlert}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Collapse in={this.state.mostrarAlerta}>
                  <Alert
                    severity={this.state.severidadAlerta}
                    onClose={this.handleCloseAlert}
                        sx={{ marginTop: 4, width:'100%'}}>
                    <AlertTitle>
                      {this.state.severidadAlerta.toUpperCase()}
                    </AlertTitle>
                      {this.state.mensajeAlerta}
                  </Alert>
                </Collapse>
              </Snackbar>
            </CardActions>
          </Card>
        </Paper>
        <Divider style={{"marginTop": 10, "marginBottom": 10}} />
        <Paper>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Listado Operaciones:
              </Typography>
              <Divider style={{"marginTop": 10, "marginBottom": 10}} />
              <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                {this.state.busqueda && (
                <AlertasTable
                  alertas={this.state.alertas}
                  columnas={this.state.columnasAlerta}
                  entidadSeleccionada={this.state.entidadSeleccionada}
                  entidadNombre={this.state.entidadSeleccionada?.nombre}
                />
                )}
              </Box>
            </CardContent>
          </Card>
        </Paper>
      </Box>
      )
    }
}

export default AlertasPage